export const ERROR_MESSAGE_YES_RETRY =
  'Sorry, something went wrong! Please try again in a few minutes.';
export const ERROR_MESSAGE_NO_RETRY =
  'Please contact us using another method while we sort out these problems.';
export const BUTTON_CTA_TEXT = 'Retry';

export const MAX_CTA_SEEN_COUNT = 3;
